<template>  
  <v-card>
    <v-toolbar flat>      
      <v-text-field flat dense filled
        v-model="term"
        append-icon="search"
        label="Search Node"
        single-line
        hide-details        
        @input="search"
        style="max-width:200px"
      ></v-text-field>        
      <v-autocomplete flat dense filled
        single-line
        v-model="id_pro"
        label="filter propinsi"
        item-text="name"
        item-value="id"   
        :items="propinsis"  
        style="max-width:200px"  
        hide-details
        class="ml-2" 
        autocomplete="off"
      ></v-autocomplete>         
      <v-spacer/>
      <v-btn fab color="green" dark small absolute right :to="{name:'master/nodes/form'}"><v-icon>add</v-icon></v-btn>                      
    </v-toolbar>
    <v-card-text class="pa-0">      
      <v-container fluid grid-list-lg class="ma-0 pa-0">
        <v-layout row>
          <v-flex xs12 md12 style="position:relative">            
            <v-data-table dense 
              :headers="headers"
              :items="items"              
              :loading="loading"
              loading-text="Loading... Please wait"
              :items-per-page="-1"
              hide-default-footer  
              :options.sync="pagination" 
              must-sort                       
            >               
              <template v-slot:item.no="{ item }">{{ ((page-1)*20)+(items.findIndex(x=>x==item)+1) }}</template>
              <template v-slot:item.level="{ item }">{{ levels[item.level] }}</template>
              <template v-slot:item.action="{ item }">
                <v-btn icon small color="blue" :to="{name:'master/nodes/form',query:{id:item.id}}"><v-icon>edit</v-icon></v-btn>
              </template>              
            </v-data-table>
            <div class="text-center">
              <v-pagination
                v-model="page"
                :length="totalPages"
                circle
                :total-visible="20"
              ></v-pagination>
            </div>
          </v-flex>          
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card> 
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/master/Node'

export default {
  data () {
    return {
      term : null, id_pro:null,
      headers:[
        {text:'No', value:'no'},
        {text:'Id', value:'id'},
        {text:'Name', value:'name'},
        {text:'Level', value:'level'},
        {text:'Parent', value:'parent_name'},
        {text:'KodePos', value:'kodepos'},
        {text:'CompareID', value:'compare_id'},
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,
      status: {1:'active',0:'inactive'},
      propinsis:[],
    }
  },
  computed:{
    levels(){
      return this.$store.getters.DICTIONS.RegionLevel;      
    }
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    },
    id_pro(newId){
      this.readItems(this.page) 
    }
  },  
  mounted () {
    model.propinsis().then(data=>{
      this.propinsis = data;
    });
    this.readItems()
  },  
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        id_pro : this.id_pro,
        sort:sortby,
      }

      model.index(params)
      .then(response => {
        this.items = response.data;
        this.totalPages = response.pagination.pageCount;               
        this.loading = false
      })
    },    
  },  
}
</script>